/** Chave do localStorage onde a carteira (favoritos) é salva. */
export const FAVORITES_STORAGE_KEY = 'favorites';

/** Cotação usada para converter valores em dólar para real. */
export const BRL_QUOTE_TICKER = 'BRL=X';

export const TAB = {
  companies: 0,
  wallet: 1,
  backup: 2,
  backupRestore: 3,
} as const;
